/** Previene Bug 2: `fopen failed` cuando photo no tiene prefijo data:image/...;base64, */
export class DataUriPhoto {
  private constructor(private readonly _value: string) {}

  /** Canonical accessor — returns the underlying data URI string. */
  get value(): string { return this._value; }

  /** Alias kept for backwards compatibility with legacy call sites. */
  getValue(): string { return this._value; }

  static from(raw: string): DataUriPhoto {
    if (!raw.startsWith('data:image/') || !raw.includes(';base64,')) {
      throw new Error('DataUriPhoto: debe comenzar con data:image/...;base64,');
    }
    return new DataUriPhoto(raw);
  }

  toJSON(): string { return this._value; }
  toString(): string { return this._value; }
}
